import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react'
import HalfSizeBanner from '../../../components/Banners/HalfSizeBanner';
import { Link } from 'react-router-dom';
import SmallCards from '../../../components/Cards/SmallCards';
import Accordions from '../../../components/Accordions/Accordions';
import { useTranslation } from '../../../hook/Translation';

export default function ClarityIILaserGenesisStyleRejuvenation() {
    const { t } = useTranslation();
    const data = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: t('clarity_ii_laser_genesis_style_rejuvenation.time'),
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: t('clarity_ii_laser_genesis_style_rejuvenation.discomfort'),
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: t('clarity_ii_laser_genesis_style_rejuvenation.downtime'),
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: t('clarity_ii_laser_genesis_style_rejuvenation.sessions'),
        }
    ];

    const accodirons = [
        {
            title: t('clarity_ii_laser_genesis_style_rejuvenation.whatTitle'),
            content: t('clarity_ii_laser_genesis_style_rejuvenation.whatDesc'),
        },
        {
            title: t('how'),
            content: t('clarity_ii_laser_genesis_style_rejuvenation.how'),
        },
        {
            title: t('benefits'),
            content: t('clarity_ii_laser_genesis_style_rejuvenation.benefits'),
        },
        {
            title: t('zone'),
            content: t('clarity_ii_laser_genesis_style_rejuvenation.zone'),
        },
        {
            title: t('healingTime'),
            content: t('clarity_ii_laser_genesis_style_rejuvenation.pairs'),
        },
        {
            title: t('when_expected_results'),
            content: t('clarity_ii_laser_genesis_style_rejuvenation.expected_results'),
        },
    ];
    return (
        <div>
            <Box>
                <HalfSizeBanner height={{ md: '460px', xs: 'auto' }}>
                    <Box sx={{ height: '100%', backgroundImage: 'linear-gradient(90deg, rgb(30, 53, 61) 50%, rgba(30, 53, 61, 0) 100%)', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', display: 'flex', justifyContent: 'center', alignItems: 'center' }} position={'relative'}>
                        <Grid container marginX={'auto'} spacing={12} paddingY={{ md: 'unset', xs: '30px' }} height={1} width={{ md: 1, xs: '90%' }}>
                            <Grid size={{ md: 6, xs: 12 }} height={1} position={'relative'} zIndex={2}>
                                <Grid container spacing={4} flexDirection={'column'} justifyContent={'center'} height={1} alignItems={{ md: 'end', xs: 'start' }}>
                                    <Grid size={'auto'}>
                                        <Typography sx={{ width: { md: '550px', xs: '100%' } }} className='wColor' variant='h1' fontSize={{ md: '2.875rem', xs: '2rem' }} fontWeight={'bold'} fontFamily={'DanmarkURW'}>{t('clarity_ii_laser_genesis_style_rejuvenation.mainTitle')}</Typography>
                                    </Grid>
                                    <Grid size={'auto'}>
                                        <Typography sx={{ width: { md: '550px', xs: '100%' } }} className='wColor' variant='h1' fontSize={{ md: '1.125rem', xs: '1rem' }} fontWeight={'500'}>{t('clarity_ii_laser_genesis_style_rejuvenation.mainDesc')}</Typography>
                                    </Grid>
                                    {/* <Grid width={{ md: '550px', xs: '100%' }}>
                                        <Button LinkComponent={Link} to={'/'} fullWidth variant='contained' className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder defaultBorderColor noShadow defaultButton defaultButton buttonTextSize' sx={{ color: 'text.secondary', backgroundColor: 'primary.main', width: 'max-content' }}>
                                            Book Now
                                        </Button>
                                    </Grid> */}
                                </Grid>
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }} height={1} position={{ md: 'relative', xs: 'absolute' }} width={1} top={{ md: 'unset', xs: 0 }} left={{ md: 'unset', xs: 0 }} sx={{ opacity: { md: 1, xs: 0.6 }, overflow: 'hidden' }}>
                                <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f08ee94c61a1.53137792.jpg`} height={1} className='fitCover' />
                            </Grid>
                        </Grid>
                    </Box>
                </HalfSizeBanner>
            </Box>

            <Box marginTop={{ md: '90px', xs: '50px' }}>
                <Box className='generalContainer' marginX={'auto'}>
                    <Grid container spacing={{md: 8, xs: 2}} position={'relative'} height={{ md: 400, xs: 'auto' }} padding={{ md: 'unset', xs: '20px' }} flexDirection={{md: 'row', xs: 'column-reverse'}}>
                        <Grid size={{ md: 6, xs: 12 }} position={{ md: 'relative', xs: 'unset' }} top={0} left={0} width={1} height={1} zIndex={{ md: 'unset', xs: 1 }} sx={{ opacity: { md: 1, xs: 1 } }}>
                            <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 8.png`} className='fitCover' width={1} height={1} />
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }} zIndex={2}>
                            <Grid container height={1} justifyContent={'center'} alignItems={'center'}>
                                <Grid size={12} height={'max-content'}>
                                    <Grid container gap={'38px'}>
                                        <Grid size={12}>
                                            <Typography textAlign={'center'} variant="h3" color="text.secondary" fontFamily={'DanmarkURW'} fontSize={{ md: '2.875rem', xs: '2rem' }} fontWeight={'bold'}>{t('clarity_ii_laser_genesis_style_rejuvenation.tech')}</Typography>
                                        </Grid>
                                        <Grid size={12}>
                                            <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={{ md: '1rem', xs: '0.875rem' }}>{t('clarity_ii_laser_genesis_style_rejuvenation.techDesc')}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid size={12} height={'max-content'} mt={'28px'}>
                                        <Grid container height={1} justifyContent={'center'}>
                                            <Grid size={{ md: 'auto', xs: 12 }}>
                                                <Button LinkComponent={Link} to={`https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e Rigjenerim i Lëkurës me Laser Genesis")}`} target='_blank' fullWidth variant='contained' className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder defaultBorderColor noShadow defaultButton defaultButton buttonTextSize' sx={{ color: 'primary.main', backgroundColor: 'secondary.main' }}>
                                                    {t('book_now')}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            <Box marginTop={{ md: '205px', xs: '50px' }} className='generalContainer' mx={'auto'}>
                <SmallCards data={data} />
            </Box>
            <Grid container gap={{ md: '80px', xs: '50px' }} className="generalContainer" sx={{ marginX: 'auto', }} marginTop={{ md: '120px', xs: '50px' }} marginBottom={{ md: '110px', xs: '50px' }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'600'}>{t('additional_information')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>
        </div>
    )
}
